import { useState, useEffect, useRef } from "react";
import "./Skillscanvas.css";

const skills = [
  { name: "HTML 5",     color: "#e34c26", logo: "https://cdn.simpleicons.org/html5" },
  { name: "CSS",        color: "#663399", logo: "https://cdn.simpleicons.org/css" },
  { name: "JavaScript", color: "#F7DF1E", logo: "https://cdn.simpleicons.org/javascript" },
  { name: "Bootstrap",  color: "#7952B3", logo: "https://cdn.simpleicons.org/bootstrap" },
  { name: "React.js",   color: "#61dafb", logo: "https://cdn.simpleicons.org/react" },
  { name: "php",        color: "#777BB4", logo: "https://cdn.simpleicons.org/php" },
  { name: "MySQL",      color: "#4479A1", logo: "https://cdn.simpleicons.org/mysql" },
  { name: "Laravel",    color: "#FF2D20", logo: "https://cdn.simpleicons.org/laravel" },
  { name: "React Native",   color: "#61dafb", logo: "https://cdn.simpleicons.org/react" },
  { name: "Supabase",   color: "#3FCF8E", logo: "https://cdn.simpleicons.org/supabase" },
];

function SkillCard({ skill, index, visible, order, onToggle, lockedCount }) {
  const locked = order !== null;

  const handleClick = () => {
    if (!locked && lockedCount >= 8) return;
    onToggle(index, !locked);
  };

  return (
    <div
      className={`skill-card${locked ? " locked" : ""} ${visible ? "fade-up" : ""}`}
      style={{ "--c": skill.color, "--card-i": index }}
      onClick={handleClick}
    >
      {locked && (
        <span className="skill-order" style={{ color: skill.color }}>
          {order}
        </span>
      )}
      <div className="skill-icon">
        <img src={skill.logo} alt={skill.name} />
      </div>
      <span className="skill-name">{skill.name}</span>
    </div>
  );
}

export default function SkillsCanvas({ introDone }) {
  const cursorRef = useRef(null);
  const containerRef = useRef(null);
  const [cursorVisible, setCursorVisible] = useState(false);
  const [gridVisible, setGridVisible] = useState(false);
  const hasTriggered = useRef(false);

  // ordered list of locked indices — position in array = order number
  const [lockedOrder, setLockedOrder] = useState([]);

  const handleToggle = (index, shouldLock) => {
    if (shouldLock) {
      if (lockedOrder.length >= 8) return;
      setLockedOrder(prev => [...prev, index]);
    } else {
      // remove this index and re-number the rest naturally
      setLockedOrder(prev => prev.filter(i => i !== index));
    }
  };

  useEffect(() => {
    if (!introDone) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasTriggered.current) {
          hasTriggered.current = true;
          setGridVisible(true);
        }
      },
      { threshold: 0.15 }
    );
    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, [introDone]);

  useEffect(() => {
    const container = containerRef.current;
    const cursor = cursorRef.current;
    const pos = { x: 0, y: 0 };
    let raf = null;

    const move = (e) => {
      pos.x = e.clientX;
      pos.y = e.clientY;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        cursor.style.transform = `translate(${pos.x}px, ${pos.y}px)`;
      });
    };

    const enter = () => setCursorVisible(true);
    const leave = () => setCursorVisible(false);

    container.addEventListener("mousemove", move);
    container.addEventListener("mouseenter", enter);
    container.addEventListener("mouseleave", leave);

    return () => {
      container.removeEventListener("mousemove", move);
      container.removeEventListener("mouseenter", enter);
      container.removeEventListener("mouseleave", leave);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <>
      <div ref={cursorRef} className={`custom-cursor ${cursorVisible ? "visible" : ""}`} />
      <div className="skills-grid" ref={containerRef}>
        {skills.map((skill, index) => {
          const posInOrder = lockedOrder.indexOf(index);
          const order = posInOrder === -1 ? null : posInOrder + 1;
          return (
            <SkillCard
              key={skill.name}
              skill={skill}
              index={index}
              visible={gridVisible}
              order={order}
              onToggle={handleToggle}
              lockedCount={lockedOrder.length}
            />
          );
        })}
      </div>
    </>
  );
}